import { useQuery } from 'react-query';

import { KimThread } from '../../../../backend/src/matter/subset/thread/kim-thread.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetKimThreads = (matterId?: string, subsetId?: string, enabled = true) => {
  const fetcher = useFetcher();

  return useQuery<KimThread[], ApiError>(
    [QueryEntity.KimThreads, { subsetId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads`),
    {
      enabled: enabled && !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
